import React from 'react';

import { ClassName, I18nText, IsDisabled } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';

import {
  GlobalCompanyTabName,
  GlobalCompanyTabRoleUID,
  GlobalCompanyTabUUID
} from '../../../globalCompanyTabsTypes';

import { UpdateGlobalCompanyTabForm } from '../../forms/UpdateGlobalCompanyTabForm';

import { SimpleModalButton } from '../../../../../helpers/buttons/SimpleModalButton';

import { words } from '../../../../../locales/keys';

interface UpdateGlobalCompanyTabModalButtonProps {
  globalCompanyTabUuid: GlobalCompanyTabUUID;
  name: GlobalCompanyTabName;
  roleIds: GlobalCompanyTabRoleUID[];
  className?: ClassName;
  i18nText?: I18nText;
  i18nTextClassName?: ClassName;
  icon?: IconsEnum;
  iconClassName?: string;
  disabled?: IsDisabled;
}

const UPDATE_GLOBAL_COMPANY_TAB_FORM = 'update-global-company-tab-form';
const UPDATE_GLOBAL_COMPANY_TAB_BUTTON = 'update-global-company-tab-button';

function UpdateGlobalCompanyTabModalButton({
  globalCompanyTabUuid,
  name,
  roleIds,
  className,
  i18nText,
  i18nTextClassName,
  icon,
  iconClassName,
  disabled
}: UpdateGlobalCompanyTabModalButtonProps) {
  return (
    <SimpleModalButton
      className={className}
      dataGa={UPDATE_GLOBAL_COMPANY_TAB_BUTTON}
      disabled={disabled}
      i18nTextClassName={i18nTextClassName}
      i18nText={i18nText}
      i18nTitle={words.editCustomTab}
      icon={icon}
      iconClassName={iconClassName}
      withoutButtons
      withoutChildrenWrapper
      withoutInitialFocus
    >
      {({ hideModal }) => (
        <UpdateGlobalCompanyTabForm
          globalCompanyTabUuid={globalCompanyTabUuid}
          name={name}
          roleIds={roleIds}
          hideModal={hideModal}
          form={UPDATE_GLOBAL_COMPANY_TAB_FORM}
        />
      )}
    </SimpleModalButton>
  );
}

export default UpdateGlobalCompanyTabModalButton;
